@import 'styles/mixins';
@import 'styles/variables';

.root {
  display: flex;
  flex-direction: column;
  margin: 10px 14px 12px 14px;
}
